import type { ListingProfileViewMode } from './listingProfileSaveReadiness'

export type ListingProfileBodyLoadingInput = {
  viewMode: ListingProfileViewMode
  /** False until target channel is chosen (create) or form should fetch source catalog. */
  shouldLoadFormPlatformData: boolean
  templateDataLoading: boolean
  otherTemplateFieldLoader: boolean
  sourcePlatformResolved: boolean
  editingRecipeId: number | null
  hydratingTitle: boolean
  hydratingPrice: boolean
  hydratingCategory: boolean
  hydratingImageMapping: boolean
  miscSectionBusy: boolean
  priceHydratePending: boolean
}

/** True while sections B–F must stay hidden and show the unified profile body loader. */
export const isListingProfileBodyLoading = (
  input: ListingProfileBodyLoadingInput
): boolean => {
  if (input.viewMode === 'list') return false
  if (!input.shouldLoadFormPlatformData) return false

  if (input.templateDataLoading || input.otherTemplateFieldLoader) return true
  if (!input.sourcePlatformResolved) return true

  if (input.viewMode === 'edit' && input.editingRecipeId != null) {
    if (
      input.hydratingTitle ||
      input.hydratingPrice ||
      input.hydratingCategory ||
      input.hydratingImageMapping ||
      input.miscSectionBusy
    ) {
      return true
    }
    if (input.priceHydratePending) return true
  }

  return false
}

export const LISTING_PROFILE_BODY_LOADING_MESSAGE = 'Loading profile sections...'
